import { NavLink, useNavigate } from "react-router-dom";
import {
  AiOutlineEnvironment,
  AiOutlineHeart,
  AiOutlineLogout,
  AiOutlineMessage,
  AiOutlineReload,
  AiOutlineSetting,
  AiOutlineShoppingCart,
  AiOutlineUser,
} from "react-icons/ai";
import { useDispatch } from "react-redux";
import { logout } from "../../store/reducers/authReducer";

const navClass = ({ isActive }) => (isActive ? "account-nav-item active" : "account-nav-item");

const AccountList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutUser = () => {
    dispatch(logout("userToken"));
    navigate("/", { replace: true });
  };

  return (
    <div className="account-side-card">
      <div className="account-side-brand">
        <span>Jooti</span>
        <strong>حساب من</strong>
      </div>

      <nav className="account-side-nav">
        <NavLink to="/user" className={navClass} end>
          <AiOutlineUser size={21} />
          <span>پروفایل</span>
        </NavLink>

        <NavLink to="/orders" className={navClass}>
          <AiOutlineShoppingCart size={21} />
          <span>سفارش‌ها</span>
        </NavLink>

        <NavLink to="/addresses" className={navClass}>
          <AiOutlineEnvironment size={21} />
          <span>آدرس‌ها</span>
        </NavLink>

        <NavLink to="/wishlist" className={navClass}>
          <AiOutlineHeart size={21} />
          <span>علاقه‌مندی‌ها</span>
        </NavLink>

        <NavLink to="/user/returns" className={navClass}>
          <AiOutlineReload size={21} />
          <span>مرجوعی</span>
        </NavLink>

        <NavLink to="/support" className={navClass}>
          <AiOutlineMessage size={21} />
          <span>پشتیبانی و تیکت</span>
        </NavLink>

        <NavLink to="/settings" className={navClass}>
          <AiOutlineSetting size={21} />
          <span>تنظیمات حساب</span>
        </NavLink>
      </nav>

      <button type="button" className="account-nav-item account-nav-logout" onClick={logoutUser}>
        <AiOutlineLogout size={21} />
        <span>خروج</span>
      </button>
    </div>
  );
};

export default AccountList;
